import { classNames } from "primereact/utils";
import { IBaseNomenclatureInputModel } from "../models/baseNomenclatureInputModel";
import styles from "./NomenclatureListPageBaseItem.module.scss";
import { SkeletonItem } from "../../components/skeletons/SkeletonItem";

interface INomenclatureListPageBaseItemProps {
  className?: string;
  item?: IBaseNomenclatureInputModel;
  isLoading: boolean;
  actionButtons?: React.ReactNode;
}

export const NomenclatureListPageBaseItem = ({
  className,
  item,
  isLoading,
  actionButtons,
}: INomenclatureListPageBaseItemProps) => {
  return (
    <div
      className={classNames(className, styles.item, {
        [styles.item_deleted]: item?.isDeleted,
      })}
    >
      <div className={styles.item_left}>
        <SkeletonItem
          isLoading={isLoading}
          value={
            <div className={styles.item_left_name}>
              {item?.name}
              <span className={styles.item_left_name_id}>(ID: {item?.id})</span>
            </div>
          }
        />
      </div>
      {actionButtons}
    </div>
  );
};
